// extracted by mini-css-extract-plugin
module.exports = {"text":"LandingTable_text__qK_LD","passed":"LandingTable_passed__xtm4E","rejected":"LandingTable_rejected__ineuW"};